

















































import Vue from 'vue';

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: true
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    // Without a label, the footer only offers Cancel
    primaryLabel: {
      type: String,
      default: ''
    },
    primaryIcon: {
      type: String,
      default: ''
    },
    primaryColor: {
      type: String,
      default: 'blue'
    },
    primaryDisabled: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    primary() {
      this.$emit('primary');
    }
  }
});
